<div class="wrap">
  <!DOCTYPE html
    PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
  <html xmlns="http://www.w3.org/1999/xhtml">
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title></title>
    <link href="https://fonts.googleapis.com/css?family=Roboto:400,500" rel="stylesheet">
  </head>
  <body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
    <span class="preheader">Your email preferences have been updated</span>
    <div style="text-align:center">
      <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%">
        <tr>
          <td id="wrap">
            <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="600"
              id="container_table">
              <tr>
                <td>

                  <table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" height="100%">
                    <!-- Header -->
                    <tr>
                      <td id="header" bgcolor="#ffffff">
                        <table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" height="100%">
                          <tr>
                            <td class="header_logo">
                              <!-- <a href="http://orbitax.com/"><img src="{{Item.OrbitaxLogoUrl}}" width="80" height="26" alt="Orbitax" border="0" /></a> -->
                              <img title="Orbitax"
                                src="https://dev-partners-wordpress-backup.s3.us-west-2.amazonaws.com/wp-content/uploads/2024/06/12171034/orbitax_logo_dark.svg"
                                alt="Orbitax Logo">
                            </td>
                          </tr>
                          <tr>
                            <td class="header_intro">
                              <h1>Your email preferences have been updated</h1>
                              <p>Thanks for updating your Orbitax email preferences. You can review and update your
                                email preferences at any time.</p>
                              <p>Thanks,<br />The Orbitax Team</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <!-- Footer -->
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </body>
  </html>
</div>